import { Position } from './position.model';

export class RoutePosition {

  public startPosition: Position;
  public startAddress: string;
  public endPosition: Position;
  public endAddress: string;

}
